<template>
  <div class="main">
    <div class="curse-content">
      <div class="curse-tex">当前位置：首页 > 复审列表 > 详情</div>
    </div>
    <div class="list-content">
      <div
        class="boxCenter"
        :style="{
          width: applyLevel2Dialog ? 'calc(100% - 800px)' : '100%',
        }"
      >
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          label-width="170px"
          class="ruleForm publish-form"
          disabled
        >
          <div class="boxMain">
            <div class="typestatus">
              <div class="item-type red" v-if="ruleForm.approve_status == 3">
                已拒绝
              </div>
              <div class="item-type green" v-if="ruleForm.approve_status == 2">
                已通过
              </div>
              <div class="item-type blue" v-if="ruleForm.approve_status == 1">
                待审核
              </div>
            </div>
            <div class="item-feedback" v-if="ruleForm.approve_status == 3">
              驳回原因：<span>{{ ruleForm.refund_reason }}</span>
            </div>
            <div class="form-tit">
              <i></i>
              <b>一、基本情况</b>
            </div>
            <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item
                  ref="project_name"
                  label="项目名称"
                  prop="project_name"
                  class="input-container"
                >
                  <el-input
                    v-model="ruleForm.project_name"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item label="申报单位" required class="input-container">
                  <el-input
                    v-model="ruleForm.organ_name"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="14">
                <el-form-item
                  ref="project_class"
                  label="项目方向"
                  prop="project_class"
                  class="input-container"
                >
                  <el-select
                    v-model="ruleForm.project_class"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in directionOne"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item
                  ref="project_direction"
                  label-width="0"
                  prop="project_direction"
                  class="input-container"
                >
                  <el-select
                    v-model="ruleForm.project_direction"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in directionTwo"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="10">
                <el-form-item
                  ref="province_id"
                  label="实施地"
                  prop="province_id"
                  class="input-container"
                >
                  <el-select
                    v-model="ruleForm.province_id"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in provinceclass"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item
                  ref="city_id"
                  label-width="0"
                  prop="city_id"
                  class="input-container"
                >
                  <el-select v-model="ruleForm.city_id" placeholder="请选择">
                    <el-option
                      v-for="item in cityclass"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item
                  ref="land_area"
                  label-width="0"
                  prop="land_area"
                  class="input-container"
                >
                  <el-input
                    v-model="ruleForm.land_area"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item
                  ref="organ_class"
                  label="申报单位属性"
                  prop="organ_class"
                  class="input-container"
                >
                  <el-select
                    v-model="ruleForm.organ_class"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in orgclass"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item
                  ref="mail_address"
                  label="通讯地址"
                  prop="mail_address"
                  class="input-container"
                >
                  <el-input
                    v-model="ruleForm.mail_address"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="邮政编码" class="input-container">
                  <el-input
                    v-model="ruleForm.post_code"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item
                  ref="email"
                  label="电子信箱"
                  prop="email"
                  class="input-container"
                >
                  <el-input
                    v-model="ruleForm.email"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="传真电话" class="input-container">
                  <el-input
                    v-model="ruleForm.fax_phone"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item
                  ref="legal_person"
                  label="法定代表人"
                  prop="legal_person"
                  class="input-container"
                >
                  <el-input
                    v-model="ruleForm.legal_person"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  ref="corporate_code"
                  label="法人代码"
                  prop="corporate_code"
                  class="input-container"
                >
                  <el-input
                    v-model="ruleForm.corporate_code"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item
                  ref="charge_name"
                  label="项目负责人姓名"
                  prop="charge_name"
                  class="input-container"
                >
                  <el-input
                    v-model="ruleForm.charge_name"
                    placeholder="请输入项目负责人姓名"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  ref="charge_job"
                  label="项目负责人职务"
                  prop="charge_job"
                  class="input-container"
                >
                  <el-input
                    v-model="ruleForm.charge_job"
                    placeholder="请输入项目负责人职务"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="项目负责人电话" class="input-container">
                  <el-input
                    v-model="ruleForm.charge_tel"
                    placeholder="请输入项目负责人办公电话"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  ref="charge_phone"
                  label="项目负责人手机"
                  prop="charge_phone"
                  class="input-container"
                >
                  <el-input
                    v-model="ruleForm.charge_phone"
                    placeholder="请输入手机号码"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item
                  ref="contact_name"
                  label="项目联系人姓名"
                  prop="contact_name"
                  class="input-container"
                >
                  <el-input
                    v-model="ruleForm.contact_name"
                    placeholder="请输入项目联系人姓名"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  ref="contact_job"
                  label="项目联系人职务"
                  prop="contact_job"
                  class="input-container"
                >
                  <el-input
                    v-model="ruleForm.contact_job"
                    placeholder="请输入项目联系人职务"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="联系人电话" class="input-container">
                  <el-input
                    v-model="ruleForm.contact_tel"
                    placeholder="请输入项目联系人办公电话"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  ref="contact_phone"
                  label="项目联系人手机"
                  prop="contact_phone"
                  class="input-container"
                >
                  <el-input
                    v-model="ruleForm.contact_phone"
                    placeholder="请输入手机号码"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item
                  ref="implement_organ_name"
                  label="实施地单位"
                  prop="implement_organ_name"
                  class="input-container"
                >
                  <el-input
                    v-model="ruleForm.implement_organ_name"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item
                  ref="implement_mail_address"
                  label="实施地通讯地址"
                  prop="implement_mail_address"
                  class="input-container"
                >
                  <el-input
                    v-model="ruleForm.implement_mail_address"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="实施地邮政编码" class="input-container">
                  <el-input
                    v-model="ruleForm.implement_post_code"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item
                  ref=""
                  label="实施地电子信箱"
                  prop=""
                  class="input-container"
                >
                  <el-input
                    v-model="ruleForm.implement_email"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="实施地传真电话" class="input-container">
                  <el-input
                    v-model="ruleForm.implement_fax_phone"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item
                  ref="implement_charge_name"
                  label="实施地负责人姓名"
                  prop="implement_charge_name"
                  class="input-container"
                >
                  <el-input
                    v-model="ruleForm.implement_charge_name"
                    placeholder="请输入实施地负责人姓名"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  ref="implement_charge_job"
                  label="实施地负责人职务"
                  prop="implement_charge_job"
                  class="input-container"
                >
                  <el-input
                    v-model="ruleForm.implement_charge_job"
                    placeholder="请输入实施地负责人职务"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="实施地负责人电话" class="input-container">
                  <el-input
                    v-model="ruleForm.implement_charge_tel"
                    placeholder="请输入实施地负责人办公电话"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  ref="implement_charge_phone"
                  label="实施地负责人手机"
                  prop="implement_charge_phone"
                  class="input-container"
                >
                  <el-input
                    v-model="ruleForm.implement_charge_phone"
                    placeholder="请输入手机号码，如无实施地，可填“无”"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item
                  ref="implement_contact_name"
                  label="实施地联系人姓名"
                  prop="implement_contact_name"
                  class="input-container"
                >
                  <el-input
                    v-model="ruleForm.implement_contact_name"
                    placeholder="请输入实施地联系人姓名"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  ref="implement_contact_job"
                  label="实施地联系人职务"
                  prop="implement_contact_job"
                  class="input-container"
                >
                  <el-input
                    v-model="ruleForm.implement_contact_job"
                    placeholder="请输入实施地联系人职务"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="实施地联系人电话" class="input-container">
                  <el-input
                    v-model="ruleForm.implement_contact_tel"
                    placeholder="请输入实施地联系人办公电话"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  ref="implement_contact_phone"
                  label="实施地联系人手机"
                  prop="implement_contact_phone"
                  class="input-container"
                >
                  <el-input
                    v-model="ruleForm.implement_contact_phone"
                    placeholder="请输入手机号码，如无实施地，可填“无”"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="boxMain">
            <div class="form-tit">
              <i></i>
              <b>二、申报单位简介（200 字以内）</b>
            </div>
            <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item
                  label="申报单位简介"
                  ref="organ_introduce"
                  prop="organ_introduce"
                  class="input-container"
                >
                  <el-input
                    type="textarea"
                    v-model="ruleForm.organ_introduce"
                    rows="5"
                    resize="none"
                    maxlength="200"
                    show-word-limit
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="form-tit">
              <i></i>
              <b>三、项目简介（200 字以内）</b>
            </div>
            <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item
                  label="项目简介"
                  ref="project_introduce"
                  prop="project_introduce"
                  class="input-container"
                >
                  <el-input
                    type="textarea"
                    v-model="ruleForm.project_introduce"
                    rows="5"
                    resize="none"
                    maxlength="200"
                    show-word-limit
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="form-tit">
              <i></i>
              <b>四、项目论证</b>
            </div>
            <el-row :gutter="24">
              <el-col :span="24">
                <div
                  class=""
                  v-for="(item, index) in ruleForm.project_assessment"
                  :key="item.id"
                >
                  <div class="titles">
                    <b v-if="ruleForm.project_assessment.length - 1 != index"
                      >*</b
                    >{{ item.title }}
                  </div>
                  <el-form-item
                    label-width="0"
                    :ref="'project_assessment.' + index + '.value'"
                    :prop="'project_assessment.' + index + '.value'"
                    :rules="{
                      required: true,
                      message: '请输入',
                      trigger: 'blur',
                    }"
                    class="input-container"
                  >
                    <el-input
                      :type="item.type"
                      v-model="item.value"
                      :placeholder="item.placeholder"
                      rows="8"
                      resize="none"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="boxMain">
            <div class="form-tit">
              <i></i>
              <b
                >五、经费预算
                <span @click="dialogVisible = true"
                  >点击查看2026年北京市社会组织服务项目预算测算参考标准</span
                ></b
              >
            </div>
            <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item
                  label="资金预算"
                  label-width="300px"
                  ref="funding_budget"
                  prop="funding_budget"
                  class="input-container"
                >
                  <el-input
                    v-model="ruleForm.funding_budget"
                    placeholder="请输入"
                  >
                    <template slot="append">元</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="16">
                <el-form-item
                  label="其中：可自筹资金数额（比例）"
                  label-width="300px"
                  ref="self_account"
                  prop="self_account"
                  class="input-container"
                >
                  <el-input
                    v-model="ruleForm.self_account"
                    placeholder="请输入"
                  >
                    <template slot="append">元</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  label-width="0"
                  ref="self_percent"
                  prop="self_percent"
                  class="input-container"
                >
                  <el-input
                    v-model="ruleForm.self_percent"
                    placeholder="请输入"
                  >
                    <template slot="append">%</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="16">
                <el-form-item
                  label="其中：需支持的资金数额（比例）"
                  label-width="300px"
                  ref="support_account"
                  prop="support_account"
                  class="input-container"
                >
                  <el-input
                    v-model="ruleForm.support_account"
                    placeholder="请输入"
                  >
                    <template slot="append">元</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  label-width="0"
                  ref="support_percent"
                  prop="support_percent"
                  class="input-container"
                >
                  <el-input
                    v-model="ruleForm.support_percent"
                    placeholder="请输入"
                  >
                    <template slot="append">%</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="num-box">
              <b><span>*</span>项目经费支出明细</b>
              <span>合计金额：{{ ruleForm.total_account }}元</span>
            </div>
            <el-form-item
              ref="account_record"
              label-width="0"
              prop="account_record"
              class="input-container"
            >
              <div class="tabel-box">
                <el-table
                  :data="ruleForm.account_record"
                  :header-cell-style="{ 'text-align': 'center' }"
                  :cell-style="{ 'text-align': 'center' }"
                  border
                  style="width: 100%"
                >
                  <el-table-column type="index" label="序号" width="100">
                  </el-table-column>
                  <el-table-column prop="type" label="费用类别" width="300">
                  </el-table-column>
                  <el-table-column prop="price" label="单价（元）" width="200">
                  </el-table-column>
                  <el-table-column prop="unit" label="标准" width="200">
                  </el-table-column>
                  <el-table-column prop="number" label="数量" width="150">
                  </el-table-column>
                  <el-table-column
                    prop="total_price"
                    label="资金金额（元）"
                    width="200"
                  >
                  </el-table-column>
                  <el-table-column prop="remark" label="备注">
                  </el-table-column>
                </el-table>
              </div>
            </el-form-item>
          </div>
          <div class="boxMain">
            <div class="form-tit">
              <i></i>
              <b>申报书</b>
            </div>
            <div class="ziplist">
              <a :href="ruleForm.organ_letter" target="_blank" class="item-look"
                >查看申报书</a
              >
            </div>
          </div>
          <div class="boxMain">
            <div class="form-tit">
              <i></i>
              <b>其他佐证</b>
            </div>
            <div class="ziplist">
              <div
                class="zip-item"
                v-for="(item, index) in ruleForm.other_file"
                :key="index"
              >
                <a :href="item.href" target="_blank">{{ item.name }}</a>
              </div>
            </div>
          </div>
          <div class="boxMain">
            <div class="form-tit">
              <i></i>
              <b>WORD/WPS可编辑版实施方案 </b>
            </div>

            <div class="ziplist">
              <div
                class="zip-item"
                v-for="(item, index) in ruleForm.word_file"
                :key="index"
              >
                <!-- target="_blank" -->
                <a :href="item.href">{{ item.name }}</a>
                <!-- <span @click="handleDelete(index, 'word_file')">删除</span> -->
              </div>
            </div>
          </div>
          <div class="boxMain">
            <div class="form-tit">
              <i></i>
              <b>PDF盖章版实施方案</b>
            </div>

            <div class="ziplist">
              <div
                class="zip-item"
                v-for="(item, index) in ruleForm.pdf_file"
                :key="index"
              >
                <a :href="item.href" target="_blank">{{ item.name }}</a>
                <!-- <span @click="handleDelete(index, 'pdf_file')">删除</span> -->
              </div>
            </div>
          </div>
          <div class="boxMain" v-if="user.recheck_project_id === ''">
            <div class="form-tit">
              <i></i>
              <b> 初审结果 </b>
            </div>

            <el-form-item
              ref="checkList"
              label-width="0"
              prop="checkList"
              class="input-container"
            >
              <div class="tabel-box">
                <el-table
                  :data="ruleForm.checkList"
                  :header-cell-style="{ 'text-align': 'center' }"
                  :cell-style="{ 'text-align': 'center' }"
                  border
                  style="width: 100%"
                >
                  <el-table-column type="index" label="序号" width="50">
                  </el-table-column>
                  <el-table-column prop="role_type" label="角色">
                    <template slot-scope="scope">
                      <span v-if="scope.row.role_type == 1">财务专家</span>
                      <span v-else-if="scope.row.role_type == 2">业务专家</span>
                      <span v-else>管理专家</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="score" label="评分"> </el-table-column>
                  <el-table-column prop="admin_name" label="评分专家">
                  </el-table-column>
                  <el-table-column prop="reason" label="专家意见">
                  </el-table-column>
                  <el-table-column prop="create_time" label="评分时间">
                    <template slot-scope="scope">
                      {{ scope.row.create_time }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="approve_time" label="操作">
                    <template slot-scope="scope">
                      <el-button
                        type="primary"
                        :disabled="false"
                        @click="showItem(scope.row)"
                      >
                        查看
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-form-item>
          </div>
        </el-form>
        <div class="btnbox">
          <!--          <span class="bor" @click="$router.back()">返回</span>-->
          <router-link
            class="bor"
            :to="`/adminhome/fdeclarelist?keyword=${search.keyword}&organ_id=${
              search.organ_id
            }&approve_status=${search.approve_status}&time=${JSON.stringify(
              search.time
            )}&project_class=${search.project_class}&project_direction=${
              search.project_direction
            }&organ_class=${search.organ_class}&province_id=${
              search.province_id
            }&city_id=${search.city_id}&page=${search.page}`"
          >
            返回
          </router-link>
          <a
            class="bor"
            :href="`${baseURL}/api/Project/preview?project_id=${id}`"
            target="_blank"
            >预览</a
          >
          <a class="bor" href="javascript:;" @click="exportProjectPdf">下载</a>
          <div class="bor" @click="applyLevel2Dialog = true">复审</div>
        </div>
      </div>
    </div>
    <attachment :dialogVisible="dialogVisible" @watchState="attachmentFun" />
    <reasonDialog :dialog="dialog" :id="id" @watchState="reasonFun" />
    <!-- 初审结果 -->
    <apply-level1-dialog
      :dialog="applyLevel3Dialog"
      :id="scoreInfo.project_id"
      :rid="scoreInfo.id"
      @watchState="dialogWatchState"
    ></apply-level1-dialog>
    <apply-level2-dialog
      :dialog="applyLevel4Dialog"
      :id="scoreInfo.project_id"
      :rid="scoreInfo.id"
      @watchState="dialogWatchState"
    ></apply-level2-dialog>

    <!-- 复审评分 -->
    <apply-level1-dialog
      :isExpert="true"
      :dialog="applyLevel1Dialog"
      :id="id"
      @watchState="watchState"
    ></apply-level1-dialog>
    <apply-level2-dialog
      :isExpert="true"
      :dialog="applyLevel2Dialog"
      :id="id"
      @watchState="watchState"
    ></apply-level2-dialog>
  </div>
</template>
<script>
import { approveProjectInfo, getProjectDetail } from "@/api/admin";
import { zhDate } from "@/tools";
import { baseURL } from "@/config";
import attachment from "../../orglogin/common/lookattachmentDialog";
import reasonDialog from "@/views/adminhome/common/reasonDialog";
import {
  cityList,
  downloadPdf,
  exportProjectPdf,
  getOrganClassList,
  getProjectClassLevelList,
  getProjectClassList,
} from "@/api";
import ApplyLevel1Dialog from "@/views/adminhome/common/ApplyLevel1Dialog";
import ApplyLevel2Dialog from "@/views/adminhome/common/ApplyLevel2Dialog";

export default {
  name: "index",
  data() {
    return {
      id: "",
      zhDate: zhDate,
      baseURL: baseURL,
      dialogVisible: false,
      dialog: false,
      orgOptions: [],
      directionOne: [],
      directionTwo: [],
      provinceclass: [],
      cityclass: [],
      orgclass: [],
      search: {
        keyword: "",
        organ_id: "",
        approve_status: "",
        time: [],
        project_class: "",
        project_direction: "",
        organ_class: "",
        province_id: "",
        city_id: "",
        page: 1,
      },
      statusOptions: [
        {
          value: 1,
          label: "待审核",
        },
        {
          value: 2,
          label: "审核通过",
        },
        {
          value: 3,
          label: "审核驳回",
        },
      ],
      ruleForm: {},
      applyLevel1Dialog: false,
      applyLevel2Dialog: false,
      applyLevel3Dialog: false,
      applyLevel4Dialog: false,
      scoreInfo: {},
    };
  },
  computed: {
    token() {
      return this.$store.state.admintoken;
    },
    user() {
      return this.$store.state.adminuser;
    },
  },
  components: {
    ApplyLevel2Dialog,
    ApplyLevel1Dialog,
    attachment,
    reasonDialog,
  },
  created() {
    this.$emit("setActive", {
      active: 6,
    });
    this.id = this.$route.query.id;
    this.search.keyword = this.$route.query.keyword;
    this.search.organ_id = this.$route.query.organ_id;
    this.search.approve_status = this.$route.query.approve_status;
    this.search.time = JSON.parse(this.$route.query.time);
    this.search.project_class = this.$route.query.project_class;
    this.search.project_direction = this.$route.query.project_direction;
    this.search.organ_class = this.$route.query.organ_class;
    this.search.province_id = this.$route.query.province_id;
    this.search.city_id = this.$route.query.city_id;
    this.search.page = this.$route.query.page;
    this.searchInit();
    this.detailInfo();
  },
  methods: {
    showItem(row, type = 1) {
      this.scoreInfo = row;
      if (type == 1) {
        this.applyLevel3Dialog = true;
      } else {
        this.applyLevel4Dialog = true;
      }
    },
    dialogWatchState() {
      this.applyLevel3Dialog = false;

      this.applyLevel4Dialog = false;
    },
    shenhe() {
      this.$confirm("是否审核通过?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let _data = await approveProjectInfo(this.id, 2, "");
          if (_data.code == 200) {
            this.$message.success(_data.message);
            this.detailInfo();
          } else {
            this.$message.error(_data.message);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },

    // 获取
    async detailInfo() {
      let _data = await getProjectDetail(this.id);
      if (_data.code == 200) {
        this.ruleForm = _data.data;
        this.ruleForm.other_file = JSON.parse(this.ruleForm.other_file);
        this.ruleForm.pdf_file = this.ruleForm.pdf_file
          ? JSON.parse(this.ruleForm.pdf_file)
          : [];
        this.ruleForm.word_file = this.ruleForm.word_file
          ? JSON.parse(this.ruleForm.word_file)
          : [];

        this.child();
        this.cityList();
      } else {
        this.$message.error(_data.message);
      }
    },

    async searchInit() {
      // 申报单位属性列表
      let res = await getOrganClassList();
      if (res.code == 200) {
        this.orgclass = res.data;
        this.orgclass.map((item) => {
          item.label = item.name;
        });
      }
      // 项目方向列表
      let _data = await getProjectClassList();
      this.directionOne = _data.data;
      this.directionOne.map((item) => {
        item.label = item.class_name;
        item.value = item.id;
      });
      // 城市列表
      let _info = await cityList();
      this.provinceclass = _info.data;
      this.provinceclass.map((item) => {
        item.label = item.name;
        item.value = item.id;
      });
    },

    // 项目方向层级列表
    async child() {
      let _data = await getProjectClassLevelList(this.ruleForm.project_class);
      this.directionTwo = _data.data;
      this.directionTwo.map((item) => {
        item.label = item.class_name;
        item.value = item.id;
      });
    },

    //城市列表
    async cityList() {
      let _data = await cityList(this.ruleForm.province_id);
      this.cityclass = _data.data;
      this.cityclass.map((item) => {
        item.label = item.name;
        item.value = item.id;
      });
    },

    async exportProjectPdf() {
      let _data = await exportProjectPdf(this.id);
      if (_data.code == 200) {
        window.open(_data.data);
        return false;
        let res = await downloadPdf(_data.data);
        let url = window.URL.createObjectURL(new Blob([res.data]));
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", "项目申报.pdf");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        this.$message.error(_data.message);
      }
    },

    attachmentFun() {
      this.dialogVisible = false;
    },
    reasonFun() {
      this.dialog = false;
      this.detailInfo();
    },

    to(path) {
      this.$router.push(path);
    },
    watchState(data) {
      this.applyLevel1Dialog = false;
      this.applyLevel2Dialog = false;
      if (data) this.detailInfo();
    },
  },
  watch: {},
  filters: {},
};
</script>

<style scoped lang="scss">
/deep/ {
  .el-input.is-disabled .el-input__inner {
    background: #fcfcfc;
    color: #333333;
  }

  .el-textarea.is-disabled .el-textarea__inner {
    background: #fcfcfc;
    color: #333333;
  }

  .el-form-item__label {
    font-size: 16px;
    letter-spacing: 1px;
    color: #333333;
    line-height: 50px;
  }

  .el-input__inner {
    height: 50px;
    font-size: 16px;
    letter-spacing: 1px;
    color: #333333;
  }

  .el-textarea__inner {
    font-size: 16px;
    letter-spacing: 1px;
    color: #333333;
  }

  .el-select {
    width: 100%;
    font-size: 16px;
    letter-spacing: 1px;
    color: #333333;
  }
}

.main {
  width: 100%;

  .curse-content {
    width: 100%;
    padding: 20px 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-right: 15px;

    .curse-tex {
      font-size: 16px;
      color: #333333;
    }

    .curse-btn {
      width: 108px;
      height: 36px;
      background-color: #5298e2;
      border-radius: 10px 10px 0px 0px;
      text-align: center;
      line-height: 36px;
      font-size: 16px;
      color: #ffffff;
      cursor: pointer;
    }
  }

  .list-content {
    width: 100%;
    min-height: 500px;

    .boxCenter {
      width: 100%;

      .btnbox {
        width: 100%;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        margin-top: 30px;
        margin-bottom: 50px;

        .tips {
          width: 100%;
          text-align: center;
          font-size: 16px;
          color: #999;
          margin-top: 10px;
        }

        .bor {
          width: 170px;
          height: 60px;
          background-color: #ffffff;
          border-radius: 10px;
          border: solid 1px #1546c5;
          text-align: center;
          line-height: 58px;
          font-size: 20px;
          letter-spacing: 2px;
          color: #1546c5;
          cursor: pointer;
          margin: 0 20px;
        }

        .green {
          width: 170px;
          height: 60px;
          background-color: #ffffff;
          border-radius: 10px;
          text-align: center;
          line-height: 60px;
          font-size: 20px;
          letter-spacing: 2px;
          color: #ffffff;
          cursor: pointer;
          background-image: linear-gradient(90deg, #77b27b 0%, #55a93e 100%);
          margin: 0 20px;
        }

        .red {
          width: 170px;
          height: 60px;
          background-color: #ffffff;
          border-radius: 10px;
          text-align: center;
          line-height: 60px;
          font-size: 20px;
          letter-spacing: 2px;
          color: #ffffff;
          cursor: pointer;
          background-image: linear-gradient(90deg, #c77d7d 0%, #bd2d2d 100%);
          margin: 0 20px;
        }
      }

      .ziplist {
        width: 100%;
        padding-bottom: 30px;

        .item-look {
          display: block;
          width: 100px;
          height: 28px;
          border-radius: 6px;
          text-align: center;
          line-height: 28px;
          font-size: 14px;
          background-image: linear-gradient(90deg, #0115a6 0%, #1546c5 100%);
          margin-left: 15px;
          cursor: pointer;
          color: #ffffff;
        }

        .zip-item {
          width: 100%;
          height: 49px;
          background-color: #f7f7f7;
          padding: 0 20px;
          margin-bottom: 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          a {
            flex: 1;
            width: 0;
            font-size: 14px;
            letter-spacing: 1px;
            color: #333333;
            cursor: pointer;
            text-decoration-line: underline;
          }

          span {
            font-size: 14px;
            letter-spacing: 1px;
            color: #999;
            cursor: pointer;
          }
        }
      }

      .boxMain {
        width: 100%;
        background: #ffffff;
        padding: 0 30px;
        box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.03);
        padding-bottom: 20px;

        .item-feedback {
          width: 100%;
          padding: 10px 0;
          //background-color: #f7f7f7;
          font-size: 16px;
          font-weight: bold;
          color: #ed3434;
          margin-top: 10px;

          span {
            color: #333333;
            font-weight: normal;
          }
        }

        .typestatus {
          width: 100%;
          padding-top: 20px;

          .item-type {
            //width: 72px;
            //height: 28px;
            border-radius: 6px;
            //text-align: center;
            //line-height: 28px;
            font-size: 18px;
            font-weight: bold;

            &.grey {
              color: #999999;
              //background-color: #f3f3f3;
            }

            &.red {
              color: #eb1d1d;
              //background-color: #ffeded;
            }

            &.green {
              color: #1ea735;
              //background-color: #e9f8e5;
            }

            &.blue {
              color: #3381c3;
              //background-color: #e5eff8;
            }
          }
        }

        .addbtn {
          width: 100%;
          display: flex;
          justify-content: center;

          span {
            width: 120px;
            height: 32px;
            background-color: #1546c5;
            border-radius: 0px 0px 10px 10px;
            text-align: center;
            line-height: 32px;
            font-size: 14px;
            letter-spacing: 1px;
            color: #ffffff;
            cursor: pointer;
          }
        }

        .tabel-box {
          width: 100%;
          padding: 20px 0;
        }

        .num-box {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 52px;
          background-color: #ecf1ff;
          padding: 0 20px;
          margin: 20px 0;

          b {
            font-size: 18px;
            font-weight: bold;
            color: #333333;

            span {
              color: #f56c6c;
              font-weight: normal;
              margin-right: 2px;
            }
          }

          span {
            font-size: 16px;
            color: #1546c5;
          }
        }

        .form-tit {
          width: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding: 30px 0;

          i {
            width: 8px;
            height: 22px;
            background-color: #1546c5;
            margin-right: 5px;
          }

          b {
            font-size: 20px;
            letter-spacing: 2px;
            color: #1546c5;
            font-weight: bold;

            span {
              font-size: 16px;
              color: red;
              margin-left: 0px;
              letter-spacing: 0;
              cursor: pointer;
              text-decoration-line: underline;
            }
          }
        }

        .titles {
          width: 100%;
          font-size: 16px;
          color: #333333;
          margin-bottom: 10px;

          b {
            color: #f56c6c;
            font-weight: normal;
          }
        }
      }
    }
  }
}
</style>
